import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ErrorOctagon = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21.728 30H10.272C9.47 30 8.717 29.688 8.151 29.121L2.879 23.849C2.312 23.283 2 22.529 2 21.728V10.272C2 9.47 2.312 8.717 2.879 8.151L8.151 2.879C8.717 2.312 9.471 2 10.272 2H21.728C22.53 2 23.283 2.312 23.85 2.879L29.122 8.151C29.689 8.717 30.001 9.471 30.001 10.272V21.728C30.001 22.53 29.689 23.283 29.122 23.85L23.85 29.122C23.284 29.689 22.53 30.001 21.729 30.001L21.728 30ZM10.272 4C10.005 4 9.754 4.104 9.565 4.293L4.293 9.565C4.104 9.754 4 10.005 4 10.272V21.728C4 21.995 4.104 22.246 4.293 22.435L9.565 27.707C9.754 27.896 10.005 28 10.272 28H21.728C21.995 28 22.246 27.896 22.435 27.707L27.707 22.435C27.896 22.246 28 21.995 28 21.728V10.272C28 10.005 27.896 9.754 27.707 9.565L22.435 4.293C22.246 4.104 21.995 4 21.728 4H10.272V4Z" />
		<path d="M17.414 16L21.707 11.707C21.888 11.526 22 11.276 22 11C22 10.448 21.552 10 21 10C20.724 10 20.474 10.112 20.293 10.293L16 14.586L11.707 10.293C11.526 10.112 11.276 10 11 10C10.448 10 10 10.448 10 11C10 11.276 10.112 11.526 10.293 11.707L14.586 16L10.293 20.293C10.112 20.474 10 20.724 10 21C10 21.552 10.448 22 11 22C11.276 22 11.526 21.888 11.707 21.707L16 17.414L20.293 21.707C20.474 21.888 20.724 22 21 22C21.552 22 22 21.552 22 21C22 20.724 21.888 20.474 21.707 20.293L17.414 16Z" />
	</svg>
);

export default ErrorOctagon;
